import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ChatCanvasEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center h-full text-gray-400">
      <div className="text-center">
        <ExternalLink size={48} className="mx-auto mb-3 opacity-50" />
        <p className="text-sm">{t('Canvas')}</p>
      </div>
    </div>
  );
};
